import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import store, { RootState } from '../index';
import FlowService from 'services/flow';
import { StatusCode } from 'libs/HTTP/constant';

interface RbotFlowStore {
  list: any[];
}
const DefalutData: RbotFlowStore = {
  // 对话流列表
  list: []
};

const slice = createSlice({
  name: 'flow',
  initialState: DefalutData,
  reducers: {
    setFlowList: (state, action: PayloadAction<any[]>) => {
      const { payload } = action;
      return { ...state, list: payload };
    }
  }
});
export const flowStore = (state: RootState) => state.flow;
export const { setFlowList } = slice.actions;
export default slice.reducer;

// 获取对话流列表
export const getFlowList = async (data: any = {}) => {
  let res: any = await FlowService.getFlowList(data);
  if (res.code === StatusCode.success) {
    let list = res.data || [];
    store.dispatch(setFlowList(list));
  }
  return Promise.resolve(res);
};
